<template>
  <div class="crumbs">
    <el-breadcrumb separator="/" style="margin-left: 18px">
      <el-breadcrumb-item :to="{ path: '/security_center' }">
				安全中心
			</el-breadcrumb-item>
      <el-breadcrumb-item>日志查看</el-breadcrumb-item>
    </el-breadcrumb>
  </div>

  <div class="container">
		<div class="login-log-container">
			<EasyTabs v-model="activeName" header>
				<EasyTabPane label="登录日志" name="login-record">
					<LoginRecordPage />
				</EasyTabPane>
				<EasyTabPane label="操作日志" name="operation-record">
					<OperationRecordPage />
				</EasyTabPane>
			</EasyTabs>
		</div>
  </div>
</template>

<script lang="ts" setup>
import LoginRecordPage from './record/LoginRecordPage.vue';
import OperationRecordPage from './record/OperationRecordPage.vue';

const activeName = ref('login-record');

</script>

<style lang="scss" scoped>
.crumbs {
  width: auto;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: start;
  margin-left: 16px;
}

.container {
  height: 100%;
  width: 100%;
  background-color: #f5f7fa;
}
.login-log-container {
  position: absolute;
  height: auto;
  width: auto;
  top: 16px;
  left: 32px;
  right: 32px;
  bottom: 24px;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  border-radius: 4px;
  background-color: rgb(255, 255, 255);
}
</style>
